<template>
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z"
      fill="#B7C3CD"
    />
  </svg>
</template>

<script>
export default { name: "DrawerBack" };
</script>

<style></style>
